<template>
  <div class="size-picker">
    <div
      class="box"
      @click="pickLang = true; $emit('menuopen')"
    >
      {{ selLang }}
    </div>
    <div
      v-if="pickLang"
      class="box box__arrow"
    >
      <i class="fas fa-arrow-right" />
    </div>
    <div
      v-for="lang in langList"
      v-show="pickLang"
      :key="langList.indexOf(lang)"
      class="box"
      @click="selectLang(lang)"
    >
      {{ lang }}
    </div>
  </div>
</template>

<script>
import Translation from "../translation.js";

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      pickLang: false
    };
  },

  computed: {
    langList: function() {
      return Translation.lang;
    },
    selLang: {
      set: function(newValue) {
        this.$emit("input", newValue);
      },
      get: function() {
        return this.value;
      }
    }
  },

  methods: {
    closeMenu: function() {
      this.pickLang = false;
    },
    selectLang: function(newLang) {
      this.selLang = newLang;
      this.closeMenu();
    }
  }
};
</script>

<style lang="scss">
.arrow {
  border: 0px;
}
</style>
